import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import EntityCommentsChat from "@/common/components/Entity/Chat/View/EntityCommentsChat";
import { EntityType, WheelOperationDto } from "@/core/api/generated/v1";

interface Props {
  wheelOperation: WheelOperationDto;
}

export default function CommentsTabContent({ wheelOperation }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <EntityCommentsChat
          entityId={wheelOperation.id!}
          entityType={EntityType.WheelOperation}
          entity={wheelOperation}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
